export const iconFontAwesomeMoneyBitcoin = (
	<i className="fa-solid fa-bitcoin"></i>
);
